import { TFunction } from 'i18next';

export interface FATCATranslations {
  title: string;
  address: string;
  dateOfBirth: string;
  firstName: string;
  lastName: string;
  usCitizen: string;
  title_confirmDetails: string;
  title_subjectToTaxation: string;
  subtitle_subjectToTaxation: string;
  subtitle_confirmDetails: string;
  section_title_tax_residency: string;
  continue: string;
  title_no_access_to_real_stocks: string;
  content_no_access_to_real_stocks: string;
  title_self_ceritification: string;
  content_self_ceritification: string;
  i_understand: string;
  iAgree: string;
  next: string;
  add_another_residency: string;
  tin_code_absent: string;
  tin_code_label: string;
  country: string;
  title_tax_residency_hub: string;
  subtitle_tax_residency_hub: string;
  insert_your_reason: string;
}

const fatcaTranslations: FATCATranslations = {
  title: 'fatca_title',
  address: 'fatca_address',
  dateOfBirth: 'fatca_date_of_birth',
  firstName: 'fatca_first_name',
  lastName: 'fatca_last_name',
  usCitizen: 'fatca_us_citizen',
  subtitle_confirmDetails:
    'Please indicate whether you pay any other taxes outside Austria.',
  title_confirmDetails: 'Confirm your details',
  title_subjectToTaxation: 'Where are you subject to taxation?',
  subtitle_subjectToTaxation:
    'Please indicate whether you pay any other taxes outside Austria. ',
  section_title_tax_residency: 'fatca_section_title_tax_residency',
  continue: 'continue',
  title_no_access_to_real_stocks: 'fatca_title_no_access_to_real_stocks',
  content_no_access_to_real_stocks: 'fatca_content_no_access_to_real_stocks',
  title_self_ceritification: 'fatca_title_self_certification',
  content_self_ceritification: 'fatca_content_self_certification',
  i_understand: 'fatca_i_understand',
  iAgree: 'I_agree',
  next: 'next',
  add_another_residency: 'add another residency',
  tin_code_absent: "I don't have a TIN for this residency",
  tin_code_label: 'TIN/NIF/DNI/NIE',
  country: 'Country',
  title_tax_residency_hub: 'In which country(s) are you a tax resident?',
  subtitle_tax_residency_hub:
    'Select your tax residencies and write your TIN number.',
  insert_your_reason: 'Insert your reason',
};

export const getFATCATranslations = (transUtil: TFunction) => {
  return Object.entries(fatcaTranslations).reduce((acc, [key, value]) => {
    acc[key as keyof FATCATranslations] = transUtil(value);

    return acc;
  }, {} as FATCATranslations);
};
